import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  TeamPickerWrap,
  TeamPickerTrigger,
  TeamPickerTriggerLabel,
  TeamPickerMenu,
  RolePickerItem,
  FieldErrorMsg,
} from './styled';
import { SA_COLORS } from '../../styled-comps';
import Icon from '../icon';

const RolePicker = ({ value, options, onChange, error, disabled }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const selected = options.find(o => o.value === value);
  const triggerText = selected ? selected.label : 'Select role...';
  const isPlaceholder = !selected;

  const handlePick = useCallback(
    nextValue => {
      onChange(nextValue);
      setOpen(false);
    },
    [onChange],
  );

  return (
    <TeamPickerWrap ref={wrapRef}>
      <TeamPickerTrigger
        type="button"
        $error={!!error}
        disabled={disabled}
        onClick={() => setOpen(o => !o)}
      >
        <TeamPickerTriggerLabel $placeholder={isPlaceholder}>
          {triggerText}
        </TeamPickerTriggerLabel>
        <Icon name="chev" size={12} />
      </TeamPickerTrigger>

      {open && (
        <TeamPickerMenu>
          {options.map(option => {
            const isSelected = option.value === value;
            return (
              <RolePickerItem
                key={option.value}
                type="button"
                $selected={isSelected}
                onClick={() => handlePick(option.value)}
              >
                <span>{option.label}</span>
                {isSelected && <Icon name="check" size={14} color={SA_COLORS.GOLD_700} />}
              </RolePickerItem>
            );
          })}
        </TeamPickerMenu>
      )}

      {error && <FieldErrorMsg>{error}</FieldErrorMsg>}
    </TeamPickerWrap>
  );
};

export default RolePicker;
